module.exports = __webpack_public_path__ + "img/play_button.72092baf.svg";